import { FormGroup, Validators } from '@angular/forms';
import { AgpFormUtil } from '@liberty-financial/agp-shared';
import * as _ from 'lodash';

import {
  isStandardSchemaPropertyDefinition,
  isStandardBaseDefinitionRequired
} from '@shared/models/schema-property-definition';

export namespace StandardSchemaUtil {
  export function attachFormGroupToSchema(formGroup: FormGroup, schema: any) {
    _.forEach(formGroup.controls, (control, key) => {
      const definition = schema[key];
      if (!definition) {
        return;
      }

      if (control instanceof FormGroup) {
        attachFormGroupToSchema(control, definition);
        return;
      }

      if (isStandardSchemaPropertyDefinition(definition)) {
        AgpFormUtil.Validators.updateRequiredIfNecessary(
          control,
          isStandardBaseDefinitionRequired(definition)
        );
      }
    });
  }

  export function removeFormGroupFromSchema(formGroup: FormGroup, schema: any) {
    _.forEach(formGroup.controls, (control, key) => {
      const definition = schema[key];
      if (!definition) {
        return;
      }

      if (control instanceof FormGroup) {
        removeFormGroupFromSchema(control, definition);
        return;
      }

      if (isStandardSchemaPropertyDefinition(definition)) {
        AgpFormUtil.Validators.updateOnCondition(control, false, [
          Validators.required
        ]);
      }
    });
  }
}
